import { forwardRef } from "react";
import { BOOKING_DATE_MAX, normalizeDateInputValue } from "@/lib/dateInput";

type Props = {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  min?: string;
  max?: string;
  className?: string;
  disabled?: boolean;
  required?: boolean;
  autoComplete?: string;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  "aria-invalid"?: boolean;
  "aria-describedby"?: string;
};

export const BookingDateInput = forwardRef<HTMLInputElement, Props>(function BookingDateInput(
  {
    id,
    value,
    onChange,
    min,
    max = BOOKING_DATE_MAX,
    className,
    disabled,
    required,
    autoComplete,
    onFocus,
    onBlur,
    "aria-invalid": ariaInvalid,
    "aria-describedby": ariaDescribedBy,
  },
  ref,
) {
  function handleChange(next: string) {
    onChange(normalizeDateInputValue(next));
  }

  return (
    <input
      ref={ref}
      id={id}
      type="date"
      className={className}
      value={value}
      min={min}
      max={max}
      disabled={disabled}
      required={required}
      autoComplete={autoComplete}
      onFocus={onFocus}
      onChange={(e) => handleChange(e.target.value)}
      onBlur={onBlur}
      aria-invalid={ariaInvalid}
      aria-describedby={ariaDescribedBy}
    />
  );
});
